var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('el-card',[_c('h5',[_vm._v("Purchased Online Tickets (Past 30 Days)")]),(_vm.visible)?_c('bar-chart',{attrs:{"labels":_vm.viewsChart.labels,"height":350,"datasets":_vm.viewsChart.datasets}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }